// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3108daa4","732":"19cf705a","977":"03d91cde"}[chunkId] + ".chunk.js";
};